import React from "react";
import SystemGraphs from "./SystemGraphs";

const SchmidtRch = () => {
  const defaultParameter = 67;

  const pageTitle = "Schmidt Rch";

  const endpoints = [
    { label: "15 Minutes", value: "display004-data15-min-ax1" },
    { label: "Daily", value: "display004-data-daily-ax1" },
  ];

  const parametersEndpoint = "display004-lookup-parameter";

  const mapEndpoint = "display004-map-points";

  return (
    <>
      <SystemGraphs
        defaultParameter={defaultParameter}
        pageTitle={pageTitle}
        endpoints={endpoints}
        parametersEndpoint={parametersEndpoint}
        mapEndpoint={mapEndpoint}
        //if rightAxis is true, then the graph will add a right axis based on the
        //current endpoints, only it will sub a 2 on the end instead of the 1
        rightAxis={true}
        displayIndex="004"
      />
    </>
  );
};

export default SchmidtRch;
